// extracted by mini-css-extract-plugin
export default {"banner_margin_bott":"slider_banner_margin_bott__iSnzt"};